DomObserver.observe('.js-previous-page-link', function (links) {
  if (document.referrer) {
    links.forEach(function (link) {
      // Convert the referrer to a URL object to extract the pathname
      var referrerUrl = new URL(document.referrer);
      // If this referrer is not from the same origin, return
      if (referrerUrl.origin !== window.location.origin) return;
      // Set the href of the link to the referrer URL
      link.href = document.referrer;
    });
  }
});